import { render } from "./JovenProfile.vue?vue&type=template&id=04a3ca1e&scoped=true"
import script from "./JovenProfile.vue?vue&type=script&lang=js"
export * from "./JovenProfile.vue?vue&type=script&lang=js"

import "./JovenProfile.vue?vue&type=style&index=0&id=04a3ca1e&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a3ca1e"]])

export default __exports__